// @material-ui/icons
import Flight from "@material-ui/icons/Flight";
import Settlement from "@material-ui/icons/Style";
import WalletIcon from "@material-ui/icons/Flight";
import Money from "@material-ui/icons/Money"
import AirlineRouteIcon from "@material-ui/icons/Flight";
import Landing from "@material-ui/icons/FlightLandOutlined";
import Audit from "@material-ui/icons/TrackChanges";

import MainLandingPage from "../layouts/Landing/RegionalLanding/landing";

import NotFound from "views/NotFound/Index.jsx";

import AirlinePaymentPage from "Regional-Views/AirlinePayment/Index.jsx";
import SettlementPage from "Regional-Views/Settlement/Index.jsx";
import WalletReport from "Regional-Views/WalletReport";
import StatementOfAccount from "Regional-Views/StatementOfAccount/Index.jsx"
import ExchangeRateAirlineView from "Regional-Views/ExchangeRateAirline/airlineView.js";
import HelpCenter from "../Regional-Views/HelpCenter/index"
import HelpIcon from "@material-ui/icons/HelpOutline"

//These routes are used by monitoring staff/personnel
const routes = [
  {
    path: "/main-landing",
    sidebarName: "Main Landing",
    navbarName: "Main Landing",
    icon: Landing,
    component: MainLandingPage,
    subMenu: [],
  },
  {
    path: "/app/psc-regional/airline-payment",
    sidebarName: "Airline Payment",
    navbarName: "Airline Payment Report",
    icon: Flight,
    subMenu: [],
    component: AirlinePaymentPage
  },
  {
    path: "/app/psc-regional/psc-settlement",
    sidebarName: " PSC Settlement",
    navbarName: "PSC Settlement",
    icon: Settlement,
    subMenu: [],
    component: SettlementPage
  },
  {
    path: "/app/psc-regional/statement-of-account",
    sidebarName: "Account Statement",
    isNotVisible: false,
    navbarName: "Account Statement",
    icon: Money,
    component: StatementOfAccount,
    subMenu: []
  },
  {
    path: "/app/psc-regional/wallet-report",
    sidebarName: "Airline Wallet Report",
    isNotVisible: false,
    navbarName: "Airline Wallet Report",
    icon: WalletIcon,
    component: WalletReport,
    subMenu: [],
  },
  {
    path: "/app/psc-regional/exchange-rate",
    sidebarName: "Exchange Rate",
    navbarName: "Exchange Rate",
    icon: AirlineRouteIcon,
    subMenu: [],
    component: ExchangeRateAirlineView,
  },
  {
    path: "/app/psc-regional/help-center",
    sidebarName: "Help Center",
    navbarName: "Help Center",
    icon: HelpIcon,
    component: HelpCenter,
    subMenu: []
  },
  {
    isNotVisible: true,
    path: "**",
    sidebarName: "Not found",
    navbarName: "Not Found",
    icon: Audit,
    subMenu: [],
    component: NotFound,

  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/regional-airline.jsx